export const setValuesHookForm = (obj, setValue) => {
    Object.entries(obj).forEach(([key, value]) => {
        setValue(key, value)
    })
}